import { AiLogo } from '@makemydeal/dr-shared-components';
import styled from 'styled-components';

export interface AiLogoIconProps {
    /** Name/identifier for the icon */
    name?: string;
    /** Font size of the icon (CSS units like '18px', '1rem', etc.) */
    fontSize?: string;
    /** Test ID for testing purposes */
    'data-testid'?: string;
    /** Accessible label for screen readers */
    ariaLabel?: string;
    /** Hide icon from screen readers */
    ariaHidden?: boolean;
}

const StyledAiLogoWrapper = styled.span<{ $fontSize: string }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;

    svg {
        width: ${({ $fontSize }) => $fontSize};
        height: ${({ $fontSize }) => $fontSize};
    }
`;

export const AiLogoIcon: React.FC<AiLogoIconProps> = ({
    name,
    fontSize = '16px',
    'data-testid': dataTestId = 'ai-logo-icon',
    ariaLabel = 'AI Logo',
    ariaHidden
}) => {
    return (
        <StyledAiLogoWrapper
            $fontSize={fontSize}
            data-testid={dataTestId}
            data-name={name}
            role={ariaHidden ? undefined : 'img'}
            aria-label={ariaHidden ? undefined : ariaLabel}
            aria-hidden={ariaHidden}
        >
            <AiLogo />
        </StyledAiLogoWrapper>
    );
};

export default AiLogoIcon;
